<template>
  <div class="right-board">
    <el-tabs v-model="currentTab" class="config_tabs" :stretch="true">
      <el-tab-pane label="属性配置" name="field">
        <div class="fields_con">
          <el-form size="small" label-width="100px">
            <div v-for="(item, index) in cmps" :key="index">
              <component
                v-if="item.name === activeItem.compType"
                :getFormId="getFormId"
                :props="activeItem"
                :is="item.content"
              ></component>
            </div>
            <div v-if="!activeItem._id" class="empty_el">未选中控件</div>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="表单配置" name="form_config">
        <FormConfig :formConf="formConf" :formConfig="formConfig" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import reg from "./custom/register";
import FormConfig from "./FormConfig.vue";

export default {
  name: "configPanel",
  components: { FormConfig },
  data() {
    return {
      currentTab: "field",
      cmps: reg,
      formIdArray: [],
    };
  },
  props: {
    activeItem: {
      type: Object,
      default: function () {
        return {};
      },
    },
    itemList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    formConf: {
      type: Object,
    },
    formConfig: {
      type: Object,
    },
  },
  created() {
    this.cmps.forEach((c) => {
      c.content = require(`./custom/configs/${c.name}`).default;
    });
  },
  methods: {
    getFormId(itemId) {
      this.formIdArray = [];
      Array.from(this.itemList, (item) => {
        if (item.compType === "row") {
          Array.from(item.columns, (column) => {
            Array.from(column.list, (col) => {
              if (col._id !== itemId) {
                this.formIdArray.push(col.id);
              }
            });
          });
        } else {
          if (item._id !== itemId) {
            this.formIdArray.push(item.id);
          }
        }
      });
      return this.formIdArray;
    },
  },
};
</script>
<style scoped>
.field-box >>> .el-scrollbar__wrap {
  overflow-x: hidden;
}
.empty_el {
  color: #ccb1ea;
  font-size: 16px;
  text-align: center;
  padding-top: 20px;
}
</style>